import request from '@/utils/httpClient'

import { UsersModel, PaysModel } from '@/model/userModel'
export const defaultUsersModel: UsersModel = {
  id: 0,
  superId: '',
  name: '',
  username: '',
  password: '',
  image: '',
  sex: '',
  idCard: '',
  email: '',
  phone: '',
  birthday: '',
  basicPay: '',
  levelId: '',
  nation: '',
  marital: '',
  nativePlace: '',
  registerPlace: '',
  registerPlaceDetail: '',
  livePlace: '',
  livePlaceDetail: '',
  homePhone: '',
  highestEducation: '',
  graduated: '',
  entryDate: '',
  leaveDate: '',
  roleIds: [],
  deptIds: [],
  createPays: [],
  updatePays: [],
  deletePays: [],
  payList: []
}

export const defaultPaysModel: PaysModel = {
  id: 0,
  key: '',
  type: '',
  name: '',
  branchName: '',
  account: ''
}

export function loginRequest(data?: object) {
  return request({
    url: 'me/login',
    method: 'post',
    data
  })
}

export function loginOutRequest() {
  return request({
    url: 'me/logout',
    method: 'put'
  })
}

export function userInfoRequest() {
  return request({
    url: 'me/info',
    method: 'get'
  })
}

export function getVerifiCode() {
  return request({
    url: 'verifyCode/login',
    method: 'get'
  })
}

export function activateAccount(data?: object) {
  return request({
    url: 'me/activeAccount',
    method: 'put',
    data
  })
}

export interface SendActivationEmailParams {
  username: string
  verifyCode?: string
  verifyCodeId?: string
}

export interface CheckActivationTokenParams {
  id: string
}

export interface ActivateAndSetPasswordParams {
  id: string
  newPassword: string
  confirmNewPassword: string
}

// 发送账户激活/重置密码邮件
export function sendActivationEmail(data: SendActivationEmailParams) {
  return request({
    url: 'me/sendActivationEmail',
    method: 'post',
    data
  })
}

// 检查激活令牌有效性
export function checkActivationToken(params: CheckActivationTokenParams) {
  return request({
    url: 'me/checkActivationToken',
    method: 'get',
    params
  })
}

// 通过邮件令牌设置新密码并激活账户
export function activateAndSetPassword(data: ActivateAndSetPasswordParams) {
  return request({
    url: 'me/activateAndSetPassword',
    method: 'put',
    data
  })
}

export function changePassword(data?: object) {
  return request({
    url: 'me/changePassword',
    method: 'put',
    data
  })
}

export function getMenuList() {
  return request({
    url: 'me/menu',
    method: 'get'
  })
}

export function getButtonsByMenuId(menuId: number) {
  return request({
    url: `me/${menuId}/buttons`,
    method: 'get'
  })
}

// 创建人员
export function createUser(data?: object) {
  return request({
    url: 'user',
    method: 'POST',
    data
  })
}

// 更新人员
export function updateUser(id: number, data?: object) {
  return request({
    url: `user/${id}`,
    method: 'put',
    data
  })
}

// 批量删除人员
export function deleteUserById(id: number) {
  return request({
    url: `user/${id}`,
    method: 'delete'
  })
}

// 根据人员
export function getUserDetailByUserId(id: number, params?: object) {
  return request({
    url: `user/${id}`,
    method: 'get',
    params
  })
}

export function getUserList(params?: object) {
  return request({
    url: 'user/page',
    method: 'get',
    params
  })
}

/**
 * 可以选择的上级
 */
export function availableSuperUser(params?: object) {
  return request({
    url: 'user/dropdowns/availableSuperUser',
    method: 'get',
    params
  })
}

/**
 * 获取业务人员
 */
export function salesmanUser(params?: object) {
  return request({
    url: 'user/dropdown/salesman',
    method: 'get',
    params
  })
}

/**
 * 获取工程师
 */
export function engineersUser(params?: object) {
  return request({
    url: 'user/dropdown/engineers',
    method: 'get',
    params
  })
}

/**
 * 获取人员下拉
 */

export function dropdownUsers(params?: object) {
  return request({
    url: 'user/dropdown/availableUses',
    method: 'get',
    params
  })
}

/**
 * 获取业务人员信息下拉列表（销售人员 + 工程师）
 */
export function dropdownPersonnelUsers(params?: { all?: boolean }): Promise<Array<{ id: number; mark: string }>> {
  return request({
    url: 'user/dropdown/personnel',
    method: 'get',
    params
  })
}

